/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invalidfiletypeerror3Inputs */

const en_invalidfiletypeerror3 = /** @type {(inputs: Invalidfiletypeerror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This file type is not supported.`)
};

const de_invalidfiletypeerror3 = /** @type {(inputs: Invalidfiletypeerror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Dateityp wird nicht unterstützt.`)
};

/**
* | output |
* | --- |
* | "This file type is not supported." |
*
* @param {Invalidfiletypeerror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const invalidfiletypeerror3 = /** @type {((inputs?: Invalidfiletypeerror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invalidfiletypeerror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invalidfiletypeerror3(inputs)
	return de_invalidfiletypeerror3(inputs)
});
export { invalidfiletypeerror3 as "invalidFileTypeError" }